/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import ExemptionDocuments from './ExemptionDocuments';

/**
 * The Exemption model module.
 * @module model/Exemption
 * @version 1.0.0
 */
class Exemption {
    /**
     * Constructs a new <code>Exemption</code>.
     * @alias module:model/Exemption
     */
    constructor() { 
        
        Exemption.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Exemption</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Exemption} obj Optional instance to populate.
     * @return {module:model/Exemption} The populated <code>Exemption</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Exemption();

            if (data.hasOwnProperty('validated')) {
                obj['validated'] = ApiClient.convertToType(data['validated'], 'Boolean');
            }
            if (data.hasOwnProperty('documents')) {
                obj['documents'] = ExemptionDocuments.constructFromObject(data['documents']);
            }
        }
        return obj;
    }


}

/**
 * @member {Boolean} validated
 */
Exemption.prototype['validated'] = undefined;

/**
 * @member {module:model/ExemptionDocuments} documents
 */
Exemption.prototype['documents'] = undefined;






export default Exemption;

